import { config } from "../../config";
import axios from "axios";
import moment from "moment";

import { LocalStorage } from '@/data/localstorage';
import { User } from '../../entity/authentication/user';
import { CorporateDetails,BranchStatus,ChargerOverallStatus,ChargerOtherStatus, UserBranchRelationshipStatus } from '../../entity/corporate/corporateDetails';
import { CorporateAddressTransformer } from '../../service/transformers/corporate';
import { QueryInfo } from "@/util";
import { EVCStationStatus } from "../../entity/location/evcstation";
import { EVChargingReservation, EVChargingReservationStatus } from '@/entity/station/reservation';
import { EVChargingReservationTransformer } from '../transformers/evcreservation';
import { Result } from '..';

export interface CpoReservationQuery {
    id?: string
    station?: {
        name?: string
    }
    corporate?: {
        name?: string
    }
    branch?: {
        name?:string
    }
    reservedBetween?: {
        from?: Date,
        to?: Date
    }
    status?: EVChargingReservationStatus
    mobile?: string
}

export interface CorporateQuery {
    id?: string
    corporateName?: string
    branch?: string
    gstNumber?: string
    status?: string
}
export interface BranchStationQuery {
    corporateId: string
    corporateName: string
    branchId: string
    branch: string  
    stationName?: string
    city?: string
    status?: EVCStationStatus  
}

export interface BranchUserQuery {
    id?: string
    mobileOrEmail?: string
    status?: string
}

export interface AdminBranchQuery {
    installationId: string
    outputId: string
    connectorID: string
}

export interface UsageReportQuery {
    mobile? : string,
    branchId: string,
    fromDate: string,
    toDate: string
}

export class CorporateService {
    async getCorporates(): Promise<any> {
        let chargerTypes = [];
        let response = await axios.get(config.api.host + "/corporate/getCorporates", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        let corporateTypesInfos: any[] = response.data.data
        corporateTypesInfos.forEach(corporate => {
            chargerTypes.push(corporate)
        });
        return Promise.resolve(corporateTypesInfos)
    }

    async getBranchStatus(): Promise<BranchStatus[]> {
        let response = await axios.get(config.api.host + "/corporate/branchStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: BranchStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new BranchStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getUserBranchRelationshipStatus(): Promise<UserBranchRelationshipStatus[]> {
        let response = await axios.get(config.api.host + "/corporate/userBranchRelationshipStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: UserBranchRelationshipStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new UserBranchRelationshipStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async createBranchDetailsByAuthor(corporateDetails: CorporateDetails, user: User): Promise<any> {
     
        let corporateInfo = {
            userId: user.id,
            corporateDetails
        }

        await axios.post(config.api.host + "/corporate/addBranchDetails", {
            data: corporateInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }
    async updateBranchDetailsByAuthor(corporateDetails: CorporateDetails, user: User): Promise<any> {
    
        let corporateInfo = {
            userId: user.id,
            corporateDetails
        }
        
        await axios.put(config.api.host + "/corporate/saveBranchDetails", {
            data: corporateInfo
        }, {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        })
        return Promise.resolve()
    }
    async getCorporateDetails(user: User): Promise<CorporateDetails> {        
        let response = await axios.get(config.api.host + "/corporate/" + user.id + "/corporateDetails", {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        })
        let profileInfo: any = response.data.data
        let corporateInfo = new CorporateDetails(
            profileInfo.corporateName,
            profileInfo.branch,
            profileInfo.mobile1,
            profileInfo.primaryContactPerson,
            profileInfo.gstNumber,
            profileInfo.email,
            profileInfo.status,
            profileInfo.mobile2,
            profileInfo.faxNumber,
            profileInfo.secondaryContactPerson,
            new CorporateAddressTransformer().transform(profileInfo),
        )
        return Promise.resolve(corporateInfo)
    }

    async corporateEditPermission(): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/"+1+"/corporateEditPermission/"+"90|L", {
            headers: {
                'Authorization' : window.localStorage.getItem("user.token")
            }
        });
        return Promise.resolve(response.data)
    }

    async corporateAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: CorporateQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size
        }
        if(query) {
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async cpoBranchAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, userId: string, query?: CorporateQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: userId
        }
        if(query) {
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchCPOBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async cpoChargingStationsAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: BranchStationQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size,
            userId: localStorage.getItem("user.id")
        }
        
        if(query) {
            if(query.corporateId) {
                queryInfo = {...queryInfo,
                    corporateId: query.corporateId
            
                }
            }
            if(query.corporateName) {
                queryInfo = {... queryInfo,
                    corporateName: query.corporateName

                }
            }
            if(query.branchId) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            if(query.branch) {
                queryInfo = {... queryInfo,
                    branch: query.branch
                }
            }
            if(query.stationName) {
                queryInfo = {... queryInfo,
                    stationName: query.stationName
                }
            }
            if(query.city) {
                queryInfo = {... queryInfo,
                    city: query.city
                }
            }
            if(query.status) {
                queryInfo = {... queryInfo,
                    status: query.status.id
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchBranchStations" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getBranchDetailsById(id: string): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/" + id, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        let corporateInfo = response.data.data;
        // let corporate = new CorporateAddressTransformer().transform(corporateInfo);
        return Promise.resolve(corporateInfo);
    }
    
    async userBranchRelationshipAtPageByPaginatedWithSizeMatchingQuery(page: number, size: number, query?: BranchUserQuery): Promise<any> {
        let queryInfo: any = {
            page: page,
            "page-size" : size
        }

        if(query) {
            if(query.id) {
                queryInfo = {... queryInfo,
                    branchId: query.id

                }
            }
            
            if(query.mobileOrEmail) {
                queryInfo = {... queryInfo,
                    mobileOrEmail: query.mobileOrEmail
                }
            }
            if(query.status) {
                queryInfo = {...queryInfo,
                    status: query.status

                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/searchUserBranchRelationship" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async deleteUserFromBranchRelationship(branchId: string, userId: string, page: number, size: number): Promise<any> {
        let response = await axios.put(config.api.host + "/corporate/updateUserBranchRelationship", {
            data: {
                branchId: branchId,
                userId: userId, 
                page: page,
                "page-size" : size
               }
        }, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        
        return Promise.resolve(response.data)
    }

    async getUserInfoByMobileOrEmail(userInfo: string, branchId: string): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/getUserInfoForBanch/"+ userInfo+"/"+branchId,{
            headers: {
                Authorization: new LocalStorage().authToken
            }
        });
        return Promise.resolve(response.data);
    }

    async addUserInfoWithBranch(branchId: string, userId: string): Promise<any> {
        let response = await axios.post(config.api.host + "/corporate/addUserInfoWithBranch",{
            data: {
                userId: userId,
                branchId: branchId
            }
        },
        {
            headers: {
                Authorization: new LocalStorage().authToken
            } 
        });
        return Promise.resolve(response.data);
    }
    
    async cpoReservationsAccessibleByCPOUserAtPageByPaginatedWithSizeMatchingQuery(user: User, page: number, size: number, query: CpoReservationQuery): Promise<Result<EVChargingReservation>> {
        let queryInfo: any = {
            page: page,
            "page-size": size
        }
        
        if (query.station && query.station.name) {
            queryInfo = {
                ...queryInfo,
                stationName: query.station.name
            }
        }
        if (query.id) {
            queryInfo = {
                ...queryInfo,
                reservationNo: query.id
            }
        }
        if (query.branch && query.branch.name) {
            queryInfo = {
                ...queryInfo,
                branchName: query.branch.name
            }
        }
        if (query.corporate && query.corporate.name) {
            queryInfo = {
                ...queryInfo,
                corporateName: query.corporate.name
            }
        }
        if (query.reservedBetween) {
            if (query.reservedBetween.from) {
                queryInfo = {
                    ...queryInfo,
                    reservedFrom: moment(query.reservedBetween.from).format("YYYY-MM-DD")
                }
            }
            if (query.reservedBetween.to) {
                queryInfo = {
                    ...queryInfo,
                    reservedTo: moment(query.reservedBetween.to).format("YYYY-MM-DD")
                }
            }
        }
        
        if (query.status) {
            queryInfo = {
                ...queryInfo,
                status: {
                    code: query.status.id
                }
            }
        }
        if (query.mobile) {
            queryInfo = {
                ...queryInfo,
                customerMobile: query.mobile
            }
        }
        
        
        let response = await axios.get(config.api.host + "/corporate/"+user.id+"/searchCpoReservations" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        }
        )
        let reservationsInfos: any[] = response.data.data
        var reservations: any = [];
        reservationsInfos.forEach(reservationInfo => {
            reservations.push({
                "reservationId" : reservationInfo.reservationId,
                "corporateName" : reservationInfo.corporateName,
                "branchName" : reservationInfo.branchName,
                "stationName" : reservationInfo.installationDetail.station.stationName,
                "userName" : reservationInfo.user.firstName + (reservationInfo.user.lastName != null ? reservationInfo.user.lastName : ""),
                "mobile" : reservationInfo.mobile,
                "reservationDate" : reservationInfo.actualStartTimeText,
                "invoiceNumber" :reservationInfo.invoiceNumber, 
                "invoiceTotal" : reservationInfo.actualNettCost,
                "invoiceDate" : reservationInfo.invoiceDate,
                "invoiceKwh" : reservationInfo.unitsConsumed,
                "status" : reservationInfo.status
                
            })
        })
        // let reservations: EVChargingReservation[] = []
        // reservationsInfos.forEach(reservationInfo => {
        //     let stationInfo: any = reservationInfo.station
        //     reservations.push(new EVChargingReservationTransformer().transform(reservationInfo))
        // });
        // console.log(JSON.stringify(reservations))
        // return Promise.resolve(new Result<EVChargingReservation>(response.data.meta.totalrecords, reservations))
        return Promise.resolve(new Result(response.data.meta.totalrecords, reservations))
    }
    
    async getCPOCharInfo(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/dashboardChargerStatus", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }

    async getBranchList(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchListForDashboard", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }
    async getBranchChargerStatus(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchChargerStatus/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getOverAllBranchChargerStatus(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getBranchOverAllChargerStatus", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    async getCorbonIndexUsage(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/getUsageChartData/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data.data)
    }
    async getChargerStatusDataForDashboard(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        if(branchId != '') {
            let response = await axios.get(config.api.host + "/admin/getChargerStatusForDashboard/"+userId+"/"+branchId, {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            })
            
            return Promise.resolve(response.data)
        } else {
            let response = await axios.get(config.api.host + "/admin/getChargerStatusForDashboard/"+userId, {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            })
            
            return Promise.resolve(response.data)
        }
        
    }
    async getGreenHousGasUsageForDashboard(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        if(branchId != "") {
            let response = await axios.get(config.api.host + "/admin/consumedGHGForAdminDashboard/"+userId+"/"+branchId, {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            })
            
            return Promise.resolve(response.data)
        } else {
            let response = await axios.get(config.api.host + "/admin/consumedGHGForAdminDashboard/"+userId+"/"+branchId, {
                headers: {
                    Authorization: new LocalStorage().authToken
                }
            })
            
            return Promise.resolve(response.data)
        }
        
    }
    async getChargerOverallStatus(): Promise<ChargerOverallStatus[]> {
       
        let response = await axios.get(config.api.host + "/admin/chargerOverallStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: ChargerOverallStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new ChargerOverallStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getChargerOtherStatus(): Promise<ChargerOtherStatus[]> {
        let response = await axios.get(config.api.host + "/admin/chargerOtherStatus", {
            headers: {
                Authorization : new LocalStorage().authToken
            }
        });
        let statusInfos: any[] = response.data.data;
        let statuses: ChargerOtherStatus[] = [];
        statusInfos.forEach((statusInfo) => {
            statuses.push(new ChargerOtherStatus(
                statusInfo.code,
                statusInfo.description,
                "",
                ""
            ))
        });
        return Promise.resolve(statuses);

    }
    async getReservatinDetailsForSelectedBranchQuery(query: AdminBranchQuery): Promise<any> {
        
        let queryInfo: any = {}

        if(query) {
            if(query.installationId) {
                queryInfo = {... queryInfo,
                    installationId: query.installationId

                }
            }
            if(query.outputId) {
                queryInfo = {... queryInfo,
                    outputId: query.outputId

                }
            }
            if(query.connectorID) {
                queryInfo = {... queryInfo,
                    connectorId: query.connectorID
                }
            }
        }
        let response = await axios.get(config.api.host + "/admin/reservationDetailsForSelectedBranch" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data.data)
    }

    async getCustomerVisitCountChartData(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/coustomerVisitCountForAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    async getTransactionCountChartData(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/transactionCountForAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    async getRevenueCountChartData(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/admin/revenueCountForAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }

    async getConsumedEnergeyChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        // if(branchId != "") {
        let response = await axios.get(config.api.host + "/corporate/consumedGHGForCPODashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
        
        // return Promise.resolve(data)
        
    }
    async getCustomerVisitCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/coustomerVisitCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    async getTransactionCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/transactionCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    async getRevenueCountChartDataForCPO(branchId: any): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/revenueCountForCPOAdminDashboard/"+userId+"/"+branchId, {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        
        return Promise.resolve(response.data)
    }
    
    async getReportList(): Promise<any> {
        let userId =  localStorage.getItem("user.id")
        let response = await axios.get(config.api.host + "/corporate/"+userId+"/reportList", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getConfigValueOfDateAndMonth(): Promise<any> {
        let response = await axios.get(config.api.host + "/corporate/monthAndDaysForReport", {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }

    async getUsageReportQuery(query: UsageReportQuery): Promise<any> {
        let queryInfo: any = {}

        if(query) {
            if(query.mobile) {
                queryInfo = {... queryInfo,
                    mobile: query.mobile

                }
            }
            if(query.branchId) {
                queryInfo = {... queryInfo,
                    branchId: query.branchId

                }
            }
            if(query.fromDate) {
                queryInfo = {... queryInfo,
                    fromDate: query.fromDate
                }
            }
            if(query.toDate) {
                queryInfo = {... queryInfo,
                    toDate: query.toDate
                }
            }
        }
        let response = await axios.get(config.api.host + "/corporate/usageReport" + new QueryInfo(queryInfo).toURLString(), {
            headers: {
                Authorization: new LocalStorage().authToken
            }
        })
        return Promise.resolve(response.data)
    }
    
    async downloadUsagePdfReport(data: any, branchId: string): Promise<any> {
     
        let URL = await axios.post(config.api.host + "/corporate/"+branchId+"/downloadReport", {
            data: data
        }, { responseType: 'blob'})
        return Promise.resolve(URL)
    }
}

